import dayjs from 'dayjs'
import { defineStore, storeToRefs } from 'pinia'

import { useAlertStore } from './useAlertStore'
import { useBoardStore } from './useBoardStore'
import { useJournalStore } from './useJournalStore'
import { useNextUpsStore } from './useNextUpsStore'
import { useNoticeStore } from './useNoticeStore'

import { useIntervalArray } from '@/composables/useIntervalArray'
import { RETRIVE_UPDATE_TIME } from '@/constants/times'
import { httpService } from '@/service/http.service'

export const useContentManagerStore = defineStore('manager', () => {
  const boardStore = useBoardStore()
  const alertStore = useAlertStore()
  const noticeStore = useNoticeStore()
  const { fetchBoards, startSlider } = boardStore
  const { fetchAlerts } = alertStore
  const { fetchNotices } = noticeStore
  const { bootstrapJournalStore } = useJournalStore()
  const { bootstrapNextUps } = useNextUpsStore()
  const { lastUpdateTime: boardsLastUpdate } = storeToRefs(boardStore)
  const { lastUpdateTime: alertsLastUpdate } = storeToRefs(alertStore)
  const { lastUpdateTime: noticesLastUpdate } = storeToRefs(noticeStore)

  async function fetchUpdateDates() {
    try {
      const updatesResponse =
        await httpService.infoboards.infoboardsPublicUpdateStatusRetrieve()

      if (!updatesResponse) return
      if (
        updatesResponse.boards &&
        (!boardsLastUpdate.value ||
          dayjs(updatesResponse.boards).diff(boardsLastUpdate.value) > 0)
      ) {
        fetchBoards()
      }
      if (
        updatesResponse.alerts &&
        (!alertsLastUpdate.value ||
          dayjs(updatesResponse.alerts).diff(alertsLastUpdate.value) > 0)
      ) {
        fetchAlerts()
      }
      if (
        updatesResponse.notices &&
        (!noticesLastUpdate.value ||
          dayjs(updatesResponse.notices).diff(noticesLastUpdate.value) > 0)
      ) {
        fetchNotices()
      }
      if (updatesResponse.frontend) {
        const lastUpdate = updatesResponse.frontend
        const persistedLastUpdate = localStorage.getItem('lastBackendUpdate')
        localStorage.setItem('lastBackendUpdate', lastUpdate)
        if (
          persistedLastUpdate &&
          dayjs(lastUpdate).diff(persistedLastUpdate) > 0
        ) {
          window.location.reload()
        }
      }
    } catch {
      // console.log(err)
    }
  }
  const { start } = useIntervalArray([RETRIVE_UPDATE_TIME], fetchUpdateDates)

  async function bootstrapContentManager() {
    fetchBoards()
    fetchAlerts()
    fetchNotices()
    bootstrapJournalStore()
    bootstrapNextUps()
    startSlider()
    start()
  }
  return { bootstrapContentManager }
})
